import React__default, { useCallback } from 'react';
import classNames from 'classnames';
import HelperStyles from '../../scss/helper.module.scss.js';
import { ReactComponent as SvgCheckedCheckBox } from '../../icons/CheckedCheckBox.svg.js';
import Style from './AppCheckbox.module.scss.js';

const AppCheckbox = ({ labelText, isChecked, onChange, styles, labelClass, checkboxStyle, checkboxClass, disabled, id }) => {
    const _onChange = useCallback(() => {
        onChange === null || onChange === void 0 ? void 0 : onChange(!isChecked);
    }, [isChecked, onChange]);
    return (React__default.createElement("div", { className: disabled ? Style.disabled : "", style: Object.assign({ display: "flex", alignItems: "center", cursor: "pointer" }, styles), onClick: _onChange, id: id },
        React__default.createElement("div", { style: Object.assign({ marginRight: "9.1px", height: "22px", width: "22px", borderRadius: "4px", border: isChecked ? "none" : "2px solid #E9E9E9" }, checkboxStyle), className: classNames(HelperStyles.center_vertical, checkboxClass) }, isChecked && React__default.createElement(SvgCheckedCheckBox, { height: "100%", width: "100%" })),
        React__default.createElement("div", { style: { lineHeight: "22px" }, className: labelClass }, labelText)));
};

export { AppCheckbox as default };
//# sourceMappingURL=AppCheckbox.js.map
